import { panelNavHtml } from '../panel-nav-html.js';

export interface ContactInfo {
  name: string;
  location: string;
  website: string;
  email: string;
  phone: string;
  positioning: string;
}

export interface ShowContactPayload {
  reason: string | null;
  company: ContactInfo;
}

/**
 * Contact card — appears when the caller asks for direct contact details.
 * Clickable phone, email and website. Dismisses on backdrop click.
 */
export class ContactCard {
  private readonly root: HTMLElement;

  constructor(root: HTMLElement) {
    this.root = root;
    this.root.classList.add('contact-overlay');
    this.root.addEventListener('click', (e) => {
      const t = e.target as HTMLElement;
      if (t === this.root || t.closest('[data-action="close"]')) {
        this.hide();
        document.dispatchEvent(new CustomEvent('merlin:nav-close', { bubbles: true }));
        return;
      }
      if (t.closest('[data-action="back"]')) {
        document.dispatchEvent(new CustomEvent('merlin:nav-back', { bubbles: true }));
      }
    });
  }

  show(payload: ShowContactPayload) {
    const c = payload.company;
    const host = c.website.replace(/^https?:\/\//, '');
    this.root.innerHTML = `
      <div class="contact-sheet">
        ${panelNavHtml()}
        <div class="contact-crest">◇</div>
        <div class="contact-name">${escape(c.name)}</div>
        <div class="contact-positioning">${escape(c.positioning)}</div>
        <div class="contact-rows">
          <a class="contact-row" href="tel:${attr(c.phone)}">
            <span class="contact-key">Phone</span>
            <span class="contact-value">${escape(c.phone)}</span>
          </a>
          <a class="contact-row" href="mailto:${attr(c.email)}">
            <span class="contact-key">Email</span>
            <span class="contact-value">${escape(c.email)}</span>
          </a>
          <a class="contact-row" href="${attr(c.website)}" target="_blank" rel="noopener">
            <span class="contact-key">Web</span>
            <span class="contact-value">${escape(host)}</span>
          </a>
          <div class="contact-row static">
            <span class="contact-key">Based</span>
            <span class="contact-value">${escape(c.location)}</span>
          </div>
        </div>
      </div>
    `;
    this.root.classList.add('visible');
  }

  hide() {
    this.root.classList.remove('visible');
  }
}

function escape(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function attr(s: string): string {
  return escape(s);
}
